export const getSubCategoryList = (catId, focusAreaOptions) => {
    if (focusAreaOptions && focusAreaOptions.categories && focusAreaOptions.categories.length) {
      const subcategoryIds: any = [];
      let foundCategory = false;
      for (let i = 0; i < Object.keys(focusAreaOptions.categories).length; i++) {
        const { categoryType, sourceTemplateCategoryId } = focusAreaOptions.categories[i];
        
        if (foundCategory && categoryType === 'category') {
          break;
        }
        
        if (foundCategory && categoryType === 'subCategory') {
          subcategoryIds.push(sourceTemplateCategoryId);
        }
        
        if (!foundCategory && categoryType === 'category' && sourceTemplateCategoryId === catId) {
          foundCategory = true;
        }
        if (!foundCategory && categoryType === 'subCategory' && sourceTemplateCategoryId === catId) {
          foundCategory = true;
          subcategoryIds.push(sourceTemplateCategoryId);
          break;
        }
      }
      return subcategoryIds;
    }
  };
